import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2fa4b8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e2fa4b8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fa4b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2fa4b8c')) {
      api.createRecord('e2fa4b8c', component.options)
    } else {
      api.reload('e2fa4b8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e2fa4b8c&scoped=true", function () {
      api.rerender('e2fa4b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/forum/index.vue"
export default component.exports